import React from 'react';
import moment from 'moment';
import Container from "../editor/container"
import Editor from '../editor'
import '../editor/styles.css'
import parseContent from '../editor/parseContent'

class Component extends React.Component {

  initialState = {
    id: false,
    content: "",
    contentObj: [],
    mode: "edit"
  }

  state = this.initialState

  componentWillMount() {
    this.setState(this.initialState)
  }

  handleChange = (event) => {
    const target = event.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    value = target.type === "file" ? target.files[0] : value;
    this.setState({
      [target.name]: value
    });
    event.preventDefault && event.preventDefault()
  }

  handleChangeEditor = (e) => {
    const target = e.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    value = target.type === "file" ? target.files[0] : value;
    this.setState({
      [target.name]: value
    });
    this.props.setState({
      [target.name]: value
    })
    e.preventDefault && e.preventDefault()    
  }

  render() {
    return (       
      <div class="">
        <Editor 
          data={this.state.contentObj} 
          mode="edit"
          onChange={this.handleChangeEditor} />
      </div>
    )
  }

}

import api from 'src/actions/api'
import setState from 'src/actions/state'
import { connect } from 'react-redux'

export default connect(function (state) {
  return {
    state: state.state.mailer_composer || state.state.initial,
    user: state.session.user
  }
}, {
  api, 
  setState: setState("mailer_composer"),
})(Component)  